import {
    Hamburguer,
    Medicine,
    Notebook,
    Popcorn
} from 'assets/img/product-details/experience'
import { colors } from 'styles/colors'

export const fullExperienceData = [
    {
        title: 'Quer dar uma ajuda de custo para seu colaborador abastecer o carro?',
        desc: 'Eu tenho a opção ajuda de custo para combustível. Assim, é possível utilizar o cartão de benefícios para abastecer o carro em diversos postos de gasolina pelo Brasil.'
    },
    {
        title: 'Precisa de auxílio alimentação e refeição?',
        desc: 'Conte com o Tudo para isso! O Tudo pode assumir, simultaneamente, as funções de vale-refeição e alimentação, permitindo que o colaborador faça suas refeições e as compras do mês com o mesmo cartão de benefícios flexíveis. As contas refeição e alimentação são separadas, auxiliando quem é beneficiário do PAT – Programa de Alimentação do Trabalhador. '
    },
    {
        title: 'Quer oferecer benefícios flexíveis ao colaborador com praticidade?',
        desc: 'Nós oferecemos versatilidade! Com apenas um cartão, a sua equipe poderá utilizar para diversos benefícios como supermercados, açougue, padarias, transporte público ou privado, pedágio, livrarias, cinema, teatro, museu e muito mais!'
    },
    {
        title: 'Quer mais benefícios flexíveis?',
        desc: 'Com a Alelo tem sempre mais! Todos os usuários do cartão Alelo Tudo podem contar com o Clube Alelo, acesso gratuito a promoções em mais de 300 estabelecimentos parceiros. Assim, é possível proporcionar economia e bem-estar ao colaborador, além de descontos exclusivos em medicamentos, cursos e lazer.'
    },
    {
        title: '',
        desc: ''
    },
    {
        title: 'Quer conceder um auxílio farmácia e opções de mobilidade?',
        desc: 'A GENTE CONECTA. Subsídio auxílio farmácia + ajuda de custos mobilidade.'
    }
]

export const fullExperiencePodData = [
    {
        title: 'Alimentação',
        desc: 'Supermercados, armazéns, mercearias, açougues e muito mais.',
        color: colors.darkGreen
    },
    {
        title: 'Refeição',
        desc: 'Restaurantes, lanchonetes, bares, padarias e similares.',
        color: colors.darkLime
    },
    {
        title: 'Farmácia',
        desc: 'Drogarias e farmácias de manipulação.',
        color: colors.claret
    },
    {
        title: 'Home Office',
        desc: 'Equipamentos e materiais de escritório, papelaria e software.',
        color: colors.purple2
    },
    {
        title: 'Educação',
        desc: 'Cursos de idiomas, creches, escolas, além de educação superior ou técnica.',
        color: colors.darkPurple
    },
    {
        title: 'Mobilidade',
        desc: 'Estacionamentos, pedágios, lava-rápidos, apps de transporte, aluguel de bicicletas e transportes públicos.',
        color: colors.darkAqua
    },
    {
        title: 'Combustível',
        desc: 'Postos de combustível.',
        color: colors.blue2
    },
    {
        title: 'Saúde e Bem-Estar',
        desc: 'Consultorias médicas, exames, laboratórios e terapia.',
        color: colors.darkTangerine
    },
    {
        title: 'Entretenimento',
        desc: 'Cinemas, livrarias, shows, teatros e apps de streaming. *Não se trata de Vale cultura previsto na Lei nº 12.761/2012',
        color: colors.coralRed
    },
    {
        title: 'Saldo Livre',
        desc: 'O saldo pro colaborador chamar de seu, aceitar em todo lugar que aceita Elo.',
        color: colors.purplePod
    }
]

export const benefitsIcons = [Hamburguer, Medicine, Popcorn, Notebook]
